import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";

export async function GetMinimumSpending(params: any, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/client/account/minimum-spending"), params, useGlobalLoader, token);
}

export async function PostMinimumSpending(params: any, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/client/account/minimum-spending"), params, useGlobalLoader);
}

export async function PutMinimumSpending(params: any, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/client/account/minimum-spending"), params, useGlobalLoader);
}

export async function DeleteMinimumSpending(params: any, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/client/account/minimum-spending"), params, useGlobalLoader);
}
